var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9244 12C18.0773 12 13.0108 18.0551 13.2376 24.6219C13.4553 30.9307 13.1725 39.1014 11.1366 45.7648C9.09458 52.4477 5.64102 56.681 0 57.2246V63.3608C5.64102 63.9044 9.09458 68.1377 11.1366 74.8206C13.1725 81.4839 13.4553 89.6546 13.2376 95.9635C13.0108 102.529 18.0773 108.585 24.9254 108.585H95.0847C101.932 108.585 106.997 102.53 106.771 95.9635C106.553 89.6546 106.836 81.4839 108.872 74.8206C110.915 68.1377 114.359 63.9044 120 63.3608V57.2246C114.359 56.681 110.915 52.4477 108.872 45.7648C106.836 39.1025 106.553 30.9307 106.771 24.6219C106.997 18.0561 101.932 12 95.0847 12H24.9234H24.9244ZM81.3559 71.4545C81.3559 80.4965 74.6807 85.9803 63.6031 85.9803H44.7458C44.2063 85.9803 43.689 85.7638 43.3076 85.3784C42.9261 84.993 42.7119 84.4703 42.7119 83.9253V36.6601C42.7119 36.1151 42.9261 35.5924 43.3076 35.207C43.689 34.8216 44.2063 34.6051 44.7458 34.6051H63.4953C72.7322 34.6051 78.7942 39.6604 78.7942 47.4222C78.7942 52.87 74.7163 57.7476 69.5207 58.6014V58.886C76.5936 59.67 81.3559 64.6185 81.3559 71.4545ZM61.5468 41.1195H50.7946V56.4642H59.8505C66.8512 56.4642 70.7115 53.616 70.7115 48.5247C70.7115 43.754 67.3922 41.1195 61.5468 41.1195V41.1195ZM50.7946 62.5532V79.4638H61.9424C69.2308 79.4638 73.0922 76.5087 73.0922 70.9551C73.0922 65.4004 69.1231 62.5522 61.4736 62.5522H50.7946V62.5532Z",
    fill: "#822AF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 96.5854,
    fill: "white",
    transform: "translate(0 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathBootstrap);
export default __webpack_public_path__ + "static/media/path-bootstrap.fcdfa857e859a56d69d6b797340b6a35.svg";
export { ForwardRef as ReactComponent };